import React from "react";
import styled from "styled-components";

const PatreonLink = styled.a`
    margin: 0 10px 10px 0;
    display: inline-block;
`;

const PatreonLogo = styled.img`
    border-radius: 3px;
    background-color: #FF424D;
    width: 116px;
    padding: 10px;
    vertical-align: middle;
`;

const PatreonButton = ({userId}) => (
    <>
        <PatreonLink href={`https://www.patreon.com/bePatron?u=${userId}`} data-patreon-widget-type="become-patron-button">
            <PatreonLogo src="/images/Digital-Patreon-Wordmark_White.png" alt="Donate via Patreon" title="Donate via Patreon" />
        </PatreonLink>
        <script async src="https://c6.patreon.com/becomePatronButton.bundle.js"></script>
    </>
);

export default PatreonButton;